<template>
  <div>
    <backend-translated-entity-plain-text
      v-if="valueIsDefined"
      :value="params.value"
      :values="params.values"
      :invalid="params.invalid"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import BackendTranslatedEntityPlainText from '@/modules/incidentsModule/views/components/BackendTranslatedEntityPlainText'

export default Vue.extend({
    name: 'BackendTranslatedEntityPlainTextRenderer',
    components: {
        BackendTranslatedEntityPlainText
    },
    computed: {
        valueIsDefined() {
            return this.params.value !== undefined
        }
    }
})
</script>
